export const EXCLUDED_ASSET_GROUPS = [
  'GeneralConductor',
];